import { Component, OnInit } from '@angular/core';
import { FooterService } from './footer.service';

@Component({
  selector: 'ngx-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})


export class FooterComponent implements OnInit {

  public valorTexto = null;
  public customLogin = null;
  public titleTexto = null;

  constructor(

    private service: FooterService,

  ) { }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    this.titleTexto = this.customLogin.textWhatsApp;
    this.valorTexto = 'https://api.whatsapp.com/send?1=pt_br&phone=+' + this.customLogin.whatsapp + '&text=Ol%C3%A1,%20tudo%20bem?%20Poderia%20me%20ajudar?';
    
  }

}


